import React, { useState, useEffect } from 'react';
import debounce from 'lodash.debounce';
import Loader from '../common/UI/Loader';
import ReactTable from '../common/UI/ReactTable';
import { CSVLink } from 'react-csv';
import services from '../api/api';
import moment from 'moment';
import { toastError, toastSuccess } from '../common/UI/Toasts';
import CustomDropdown from '../common/UI/Dropdown';
import DatePicker from 'react-datepicker';
import { Button } from 'react-bootstrap';

const PharmacistReporting = () => {
  const columns = [
    {
      Header: 'Order Number',
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <span
            style={{
              color:
                row?.original?.subscription_id &&
                row.original.orderItemArray[0].follow_up_ans?.length
                  ? 'red'
                  : 'black',
            }}
          >
            {row.original.order_number}
          </span>
        );
      },
    },
    {
      Header: 'Patient Name',
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <div>
            {row?.original?.patient?.first_name}{' '}
            {row?.original?.patient?.last_name}
          </div>
        );
      },
    },
    {
      Header: 'Order Date',
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <span
            style={{
              color:
                row?.original?.subscription_id &&
                row.original.orderItemArray[0].follow_up_ans?.length
                  ? 'red'
                  : 'black',
            }}
          >
            {moment(row?.original?.createdAt).format('MM/DD/YYYY')}
          </span>
        );
      },
    },
    {
      Header: 'Product/Medication Name',
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row }) => {
        let order_item_cost = row.original?.orderItemArray?.reduce(
          (prev, curr) =>
            curr?.product?.name ? prev + `${curr?.product?.name},` : prev,
          '',
        );
        return (
          <div
            style={{
              color:
                row?.original?.subscription_id &&
                row.original.orderItemArray[0].follow_up_ans?.length
                  ? 'red'
                  : 'black',
            }}
          >
            {order_item_cost}
          </div>
        );
      },
    },
    {
      Header: 'Order Total(Ex. VAT)',
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <span
            style={{
              color:
                row?.original?.subscription_id &&
                row.original.orderItemArray[0].follow_up_ans?.length
                  ? 'red'
                  : 'black',
            }}
          >
            {row.original.originalPriceTotal}
          </span>
        );
      },
    },
    {
      Header: 'Order Total VAT',
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <span
            style={{
              color:
                row?.original?.subscription_id &&
                row.original.orderItemArray[0].follow_up_ans?.length
                  ? 'red'
                  : 'black',
            }}
          >
            {row.original.VatRateTotal}
          </span>
        );
      },
    },
    {
      Header: 'Delivery Charge',
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <span
            style={{
              color:
                row?.original?.subscription_id &&
                row.original.orderItemArray[0].follow_up_ans?.length
                  ? 'red'
                  : 'black',
            }}
          >
            {row.original.delivery_total}
          </span>
        );
      },
    },
    {
      Header: 'Delivery VAT',
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <span
            style={{
              color:
                row?.original?.subscription_id &&
                row.original.orderItemArray[0].follow_up_ans?.length
                  ? 'red'
                  : 'black',
            }}
          >
            {row.original.deliveryVatRate}
          </span>
        );
      },
    },
    {
      Header: 'Order Total',
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <span
            style={{
              color:
                row?.original?.subscription_id &&
                row.original.orderItemArray[0].follow_up_ans?.length
                  ? 'red'
                  : 'black',
            }}
          >
            {row.original.order_total}
          </span>
        );
      },
    },
    {
      Header: 'Total VAT',
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <span
            style={{
              color:
                row?.original?.subscription_id &&
                row.original.orderItemArray[0].follow_up_ans?.length
                  ? 'red'
                  : 'black',
            }}
          >
            {row.original.sumOfDeliveryVatAndTotalVat}
          </span>
        );
      },
    },
    {
      Header: 'Pharmacy Name',
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <div
            style={{
              color:
                row?.original?.subscription_id &&
                row.original.orderItemArray[0].follow_up_ans?.length
                  ? 'red'
                  : 'black',
            }}
          >
            {dates?.pharmacist}
          </div>
        );
      },
    },
    {
      Header: 'Total Trade Price',
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row }) => {
        let totalTradePrice = 0;
        row.original.orderItemArray.forEach((el) => {
          totalTradePrice = totalTradePrice + el?.trade_price;
        });
        return (
          <div
            style={{
              color:
                row?.original?.subscription_id &&
                row.original.orderItemArray[0].follow_up_ans?.length
                  ? 'red'
                  : 'black',
            }}
          >
            {totalTradePrice.toFixed(2)}
          </div>
        );
      },
    },
    {
      Header: 'Order Item Cost',
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row }) => {
        let totalPrice = 0;
        row.original.orderItemArray.forEach((el) => {
          totalPrice = totalPrice + el?.calculatedTradePrice;
        });
        return (
          <div
            style={{
              color:
                row?.original?.subscription_id &&
                row.original.orderItemArray[0].follow_up_ans?.length
                  ? 'red'
                  : 'black',
            }}
          >
            {totalPrice.toFixed(2)}
          </div>
        );
      },
    },
  ];

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [csvData, setCsvData] = useState([]);

  const [pharmacistOptions, setPharmacistOptions] = useState([]);
  const [selectedPharmacist, setSelectedPharmacist] = useState();
  const [selectedDates, setSelectedDates] = useState({
    start_date: '',
    end_date: '',
  });
  const [dates, setDates] = useState({});

  useEffect(() => {
    getPharmacists();
  }, []);

  useEffect(() => {
    loadCSVdata(data);
  }, [data]);

  const getPharmacists = () => {
    const params = { showall: true, role: 'pharmacist' };
    services
      .getUsers(params)
      .then((res) => {
        let pharmacists = res.data.data.docs.map((el) => {
          return {
            label: `${el?.first_name} ${el?.last_name}`,
            value: el?._id,
          };
        });
        setPharmacistOptions(pharmacists);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const CSVheaders = [
    { label: 'Order Number', key: 'order_number' },
    { label: 'Patient Name', key: 'patient_name' },
    { label: 'Order Date', key: 'createdAt' },
    { label: 'Product/Medication Name', key: 'medication_name' },
    { label: 'Order Total(Ex. VAT)', key: 'order_total_exVAT' },
    { label: 'Order Total VAT', key: 'order_total_vat' },
    { label: 'Delivery Charges', key: 'delivery_total' },
    { label: 'Delivery VAT', key: 'delivery_vat' },
    { label: 'Order Total', key: 'order_total' },
    { label: 'Total VAT', key: 'total_vat' },
    { label: 'Pharmacy Name', key: 'pharmacy_name' },
    { label: 'Total Trade Price', key: 'total_trade_price' },
    { label: 'Order Item Cost', key: 'order_item_cost' },
    { label: 'isSubscription', key: 'isSubscription' },
    { label: 'Dispatched Date', key: 'dispatched_date' },
  ];

  const loadCSVdata = (orderdata) => {
    const modifyorderdata = orderdata?.length
      ? orderdata?.map((el) => {
          let order_item_cost = 0;
          let totalTradePrice = 0;
          el?.orderItemArray?.forEach((el) => {
            order_item_cost = order_item_cost + el?.calculatedTradePrice;
            totalTradePrice = totalTradePrice + el?.trade_price;
          });

          let order_item_name = el?.orderItemArray?.reduce(
            (prev, curr) =>
              curr?.product?.name ? prev + `${curr?.product?.name},` : prev,
            '',
          );
          return {
            order_number: el?.order_number,
            patient_name: `${el?.patient.first_name} ${el?.patient.last_name}`,
            createdAt: `${moment(el?.createdAt).format('MM/DD/YYYY')}`,
            medication_name: order_item_name,
            order_total_exVAT: el?.originalPriceTotal,
            order_total_vat: el?.VatRateTotal,
            delivery_total: el?.delivery_total,
            delivery_vat: el?.deliveryVatRate,
            order_total: el?.order_total,
            total_vat: el?.sumOfDeliveryVatAndTotalVat,
            pharmacy_name: dates.pharmacist,
            total_trade_price: totalTradePrice.toFixed(2),
            order_item_cost: order_item_cost,
            dispatched_date: `${moment(el?.dispatched_date).format(
              'MM/DD/YYYY',
            )}`,
            isSubscription:
              el?.subscription_id && el.orderItemArray[0].follow_up_ans?.length
                ? true
                : false,
          };
        })
      : [];
    setCsvData(modifyorderdata);
  };

  const handleFilterDataClick = () => {
    if (
      selectedPharmacist &&
      selectedDates.start_date !== '' &&
      selectedDates.end_date !== ''
    ) {
      if (
        new Date(selectedDates.start_date) > new Date(selectedDates.end_date)
      ) {
        toastError(`Start date should be less than End date`);
      } else {
        let params = {
          pharmacist_id: selectedPharmacist?.value,
          sdt: selectedDates?.start_date,
          edt: selectedDates?.end_date,
        };
        setLoading(true);
        services
          .getOrderAccountingData(params)
          .then((res) => {
            setData(res.data.data);
            setDates({
              start_date: selectedDates.start_date,
              end_date: selectedDates.end_date,
              pharmacist: selectedPharmacist.label,
            });
            setLoading(false);
          })
          .catch((err) => {
            console.log('err', err);
          });
      }
    } else {
      !selectedPharmacist
        ? toastError('Please Select Pharmacist')
        : toastError(
            `Please Select ${
              selectedDates.start_date == '' ? 'Start' : 'End'
            } Date`,
          );
    }
  };

  return (
    <>
      <div className="content_wrapper all_products_main">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="box_main">
                <div
                  className="header_top d-flex"
                  style={{ justifyContent: 'space-between' }}
                >
                  <h3>Pharmacist Reporting</h3>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <span style={{ fontSize: '14px', color: 'red' }}>
                      Follow Up Orders
                    </span>
                  </div>
                </div>

                <div className="middle_main">
                  <div className="row">
                    <div className="col-md-3">
                      <label className="form-label">Pharmacist</label>
                      <CustomDropdown
                        className=""
                        options={pharmacistOptions}
                        isSearchable={false}
                        height={'40px'}
                        placeholder={'Select Pharmacist'}
                        placeholderColor={'#9aa5ad'}
                        border={'1 px solid #9aa5ad'}
                        onChange={(value) => {
                          setSelectedPharmacist(value);
                        }}
                        value={selectedPharmacist}
                        isLoading={!pharmacistOptions.length}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Start Date</label>
                      <DatePicker
                        dateFormat={'MM/dd/yyyy'}
                        placeholderText="Select Start Date"
                        selected={selectedDates.start_date}
                        onChange={(val) => {
                          setSelectedDates((prev) => {
                            return { ...prev, start_date: val };
                          });
                        }}
                        className="form-control form-input px-4"
                        name="start_date"
                        inputDateFormat="MM/dd/yyyy"
                        maxDate={new Date()}
                        onDaySelect={() => {}} //when day is clicked
                        onBlur={() => console.log('blur')}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">End Date</label>
                      <DatePicker
                        dateFormat={'MM/dd/yyyy'}
                        placeholderText="Select End Date"
                        selected={selectedDates.end_date}
                        onChange={(val) => {
                          setSelectedDates((prev) => {
                            return { ...prev, end_date: val };
                          });
                        }}
                        className="form-control form-input px-4"
                        name="start_date"
                        inputDateFormat="MM/dd/yyyy"
                        maxDate={new Date()}
                        onDaySelect={() => {}} //when day is clicked
                        onBlur={() => console.log('blur')}
                      />
                    </div>
                    <div className="col-md-3 mt-4 text-end">
                      <Button
                        className="me-4 order_btns p-3"
                        onClick={handleFilterDataClick}
                      >
                        Filter Data
                      </Button>
                      <Button
                        className="me-4 order_btns p-3"
                        disabled={!data.length}
                      >
                        <CSVLink
                          data={csvData}
                          filename={`orders_${moment(dates.start_date).format(
                            'YYYY_MM_DD',
                          )} to ${moment(dates.end_date).format(
                            'YYYY_MM_DD',
                          )}.csv`}
                          target="_blank"
                          headers={CSVheaders}
                          style={{ color: '#fff' }}
                        >
                          Export Orders
                        </CSVLink>
                      </Button>
                    </div>
                  </div>
                  {Object.keys(dates).length ? (
                    <div className="mt-4 fs-24">
                      {' '}
                      Order data of{' '}
                      <span className="fw-bold">
                        {dates.pharmacist}
                      </span> from{' '}
                      <span className="fw-bold">
                        {moment(dates.start_date).format('MM/DD/YYYY')}
                      </span>{' '}
                      to{' '}
                      <span className="fw-bold">
                        {moment(dates.end_date).format('MM/DD/YYYY')}
                      </span>
                    </div>
                  ) : null}
                  {loading ? (
                    <Loader loading={loading} />
                  ) : (
                    <ReactTable
                      title="Subscription Orders"
                      tableColumns={columns}
                      tableData={data}
                      seeAll={true}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PharmacistReporting;
